import { create } from 'zustand';

import { User } from '../../../../../../../entities/users';

// NOTE: There are a lot of `User` types floating around. I'd like to settle on this one, which is based on the
// user schema returned from the User Management domain. This type is the most generic struct that a lot of other
// components already use and which is included in associated data returned from other endpoints. Although the
// Action Input, and therefore the Awards modal, has its own type of User struct, I think it will be better in the
// long term to use this one for consistency going forward and isolating any data conversions to components that
// require special types.
type AwardModalStoreProps = {
	isOpen: boolean;
	onClose: () => void;
	onOpen: () => void;
	onOpenWithRecipient: (recipient: User) => void;
	recipient: null | User;
};

export const useAwardModalStore = create<AwardModalStoreProps>((set) => ({
	isOpen: false,
	onClose: () => set({ isOpen: false }),
	onOpen: () => set({ isOpen: true, recipient: null }),
	onOpenWithRecipient: (recipient: User) => set({ isOpen: true, recipient }),
	recipient: null,
}));

export const useAwardModal = () => useAwardModalStore((state) => state);
